import React, { useEffect } from 'react';
import './Toast.css';

const Toast = ({ message, show, onClose, duration = 2000 }) => {
  useEffect(() => {
    let timer;
    if (show) {
      timer = setTimeout(() => {
        onClose();
      }, duration);
    }
    return () => {
      clearTimeout(timer);
    };
  }, [show, duration, onClose]);

  if (!show) {
    return null;
  }

  return (
    <div className="toast-container">
      <div className="toast-message">
        {message}
      </div>
    </div>
  );
};

export default Toast;
